import {
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Grid,
  MenuItem,
} from '@mui/material'
import React from 'react'

const EyelidAssessment = ({ moduleValues, setModuleValues, side }) => (
  <Grid item xs={12} lg={6}>
    <FormControl fullWidth>
      <InputLabel>Eyelid Assessment</InputLabel>
      <Select
        value={moduleValues?.[`Eyelid Assessment (${side})`] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            [`Eyelid Assessment (${side})`]: e.target.value,
          }))
        }
        label="Eyelid Assessment"
      >
        {['Swelling', 'Laceration', 'Ptosis', 'Normal'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default EyelidAssessment
